import { createContext, useContext, useEffect, useState } from "react";

const PrivacyContext = createContext({ financialPrivacy: false, setFinancialPrivacy: () => {} });

export const PrivacyProvider = ({ children }) => {
  const [financialPrivacy, setFinancialPrivacy] = useState(() => localStorage.getItem("financialPrivacy") === "1");
  useEffect(() => {
    localStorage.setItem("financialPrivacy", financialPrivacy ? "1" : "0");
  }, [financialPrivacy]);
  return (
    <PrivacyContext.Provider value={{ financialPrivacy, setFinancialPrivacy }}>
      {children}
    </PrivacyContext.Provider>
  );
};

export const usePrivacy = () => useContext(PrivacyContext);
